import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import ImportAccountMain from './views/main';
import { HasPermission } from "Core/security"
import { Navigate } from "react-router-dom";

const ImportAccountView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "impp4") && <Route path="list" element={<ImportAccountMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default ImportAccountView